"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactMainInfo = require("./ContactMainInfo");
Object.keys(_ContactMainInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactMainInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactMainInfo[key];
    }
  });
});